<template>
    <transition name="fade">
        <div class="LanguageSelection" v-show="languageSelectionVisible">
            <div class="lc-container">
                <img class="lc-logo" :src="publicPath+'/media/'+logoURL" alt="">
                <div class="lc-title">Bitte wählen Sie eine Sprache aus:</div>
                <div class="lc-language" @click="loadTour('de')">
                    <img class="lc-flag" src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Flag_of_Germany.svg/1920px-Flag_of_Germany.svg.png" alt="">
                    <span>Deutsch</span>
                </div>
                <div class="lc-language" @click="loadTour('en')">
                    <img class="lc-flag" src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg/1920px-Flag_of_the_United_Kingdom_%283-5%29.svg.png" alt="">
                    <span>English</span>
                </div>
            </div>          
        </div>
    </transition>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data: () => ({
        publicPath: process.env.BASE_URL,
        languageSelectionVisible: false
    }),
    computed: {
        ...mapGetters(['panoramaTourZIPEN','panoramaTourZIP','showLanguageSelection','logoURL']),
    },
    methods: {
        loadTour(language){
            let zip = language == 'de' ? this.panoramaTourZIP : this.panoramaTourZIPEN;
            this.$store.dispatch('loadPanoramaTour', {zip: zip, preview: false}).then(() => {
                console.log("Data from CMS is loaded!");
            })
            this.languageSelectionVisible = false;
        }
    },
    watch: {
        showLanguageSelection(){
            this.languageSelectionVisible = this.showLanguageSelection;
        }
    },
    mounted(){
        document.getElementsByClassName("lc-container")[0].style.opacity = 1; 
    }
}
</script>

<style scoped>
.LanguageSelection{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 101;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgb(139, 139, 139);
}
.lc-container{
    opacity: 0;
    transition: 1s opacity ease-in;
    display: flex;
    flex-direction: column;
}
.lc-logo{
    width: 350px;
    height: auto;
}
.lc-title{
    font-weight: bolder;
    font-size: 20px;
    text-align: center;
    margin: 50px;
}
.lc-language{
    cursor: pointer;
    border: 2px solid black;
    padding: 10px;
    margin: 10px;
    color: black;
    text-align: center;
    font-size: 18px;
}
.lc-language:hover{
   background: var(--primaryColor);
   border: 2px solid var(--primaryColor);;
}
.lc-flag{
    width: 50px;
    height: auto;
    margin-right: 20px;
}
</style>